import React from 'react';
import './ChartLegend.css';

const LEGEND_ITEMS = [
    { label: 'Cash Inflows', color: 'rgb(17, 140, 79)', fill: 'rgba(17, 140, 79, 0.8)' },
    { label: 'Cash Outflows', color: 'rgb(239, 68, 68)', fill: 'rgba(239, 68, 68, 0.8)' },
    { label: 'Ending Cash Balance', color: 'rgb(70, 99, 145)', fill: 'rgba(70, 99, 145, 0.1)' },
];

const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(value);
};

const ChartLegend = ({ metrics }) => {
    return (
        <div className="chart-legend-sticky">
            {LEGEND_ITEMS.map(item => (
                <div key={item.label} className="legend-item">
                    <span className="legend-dot" style={{ backgroundColor: item.color }} />
                    <span className="legend-label">{item.label}</span>
                </div>
            ))}
            
            {metrics && (
                <div className="legend-metrics">
                    {/* Current Cash Balance Block */}
                    <div className="metric-block">
                        <div className="metric-item">
                            <span className="metric-dot" style={{ backgroundColor: 'rgb(70, 99, 145)' }} />
                            <div className="metric-content">
                                <div className="metric-value">{formatCurrency(metrics.currentCashBalance)}</div>
                                <div className="metric-label">Cash balance</div>
                            </div>
                        </div>
                    </div>
                    
                    {/* Inflows and Outflows Block */}
                    <div className="metric-block">
                        <div className="metric-item">
                            <div className="metric-content">
                                <div className="metric-value positive">+{formatCurrency(metrics.projectedInflows)}</div>
                                <div className="metric-label">Projected inflows</div>
                            </div>
                        </div>
                        <div className="metric-item">
                            <div className="metric-content">
                                <div className="metric-value negative">-{formatCurrency(metrics.projectedOutflows)}</div>
                                <div className="metric-label">Projected outflows</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChartLegend;


